import { Link } from "react-router";

export default function Parallax() {
  return (
    <div className="relative h-80 parallax">
        <img className="object-cover fixed top-0 left-0 w-full h-full" src="/home/l1.jpg" alt="Pousada Casa Kuava" />
        <div className="flex flex-col items-center px-4 py-14 md:py-16 parallax">
            <h3 className="center text-white text-2xl">Maragogi é lindo demais</h3>
            <p className="center text-white text-center py-6">
                Águas claras e mornas, ondas calmas, area branquinha, piscinas naturais...<br/>
                Tudo isso e muito mais tem em um lugar chamado Maragogi
            </p>
            <Link to="/reservar" className="text-white bg-stone-500 rounded py-2 px-5">
              RESERVAR
            </Link>
        </div>
    </div>
  )
}